import axios from 'axios'

import { checkKeycloakToken } from './auth/hooks/useKeycloakToken'

export const RestApiModern = axios.create({
  baseURL: '/',
})

RestApiModern.defaults.headers.common = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
  'Content-Type': 'application/json',
}

RestApiModern.interceptors.request.use(checkKeycloakToken)
